import React from "react";
import classNames from "classnames";

// import Skolkovo from "../../assets/images/skolkovo.svg";
import AbkrLogo from "../../assets/svg/AbkrLogo.svg";

import styles from "./Footer.module.scss";

const MembershipSection = ({ scrollToTop }) => {
  return (
    <section
      className={classNames(styles.FooterLayout, styles.MembershipSection)}
    >
      <div className={styles.Partner}>
        <p className={styles.PartnerTitle}>
          Член Ассоциации Брендинговых <br />
          Компаний России
        </p>

        <img className={styles.PartnerLogo} src={AbkrLogo} alt="" />
      </div>

      <div className={styles.Partner}>
        {/* <p className={styles.PartnerTitle}>
                Официальный <br />
                маркетинг-провайдер
            </p>

            <img className={styles.PartnerLogo} src={Skolkovo} alt="" /> */}
      </div>

      <div className={styles.RightAlign}>
        <div
          className={classNames(styles.ButtonToTop, styles.HiddenOnMobile)}
          onClick={scrollToTop}
        >
          Наверх
        </div>
      </div>
    </section>
  );
};

export default MembershipSection;
